import { Button } from "react-bootstrap";

const PrintTable = ({ tableId, logoUrl, title, removeLastColumn = true }) => {
    const printTable = () => {
      const tableElement = document.getElementById(tableId);
      if (!tableElement) {
        alert('Table not found!');
        return;
      }
  
      let tableHTML = tableElement.innerHTML;
  
      if (removeLastColumn) {
        // Create a temporary DOM element to manipulate the table
        const tempTable = document.createElement('table');
        tempTable.innerHTML = tableHTML;
  
        // Remove the last column from each row
        const rows = tempTable.querySelectorAll('tr');
        rows.forEach((row) => {
          const cells = row.querySelectorAll('td, th');
          if (cells.length > 0) {
            row.removeChild(cells[cells.length - 1]);
          }
        });
  
        // Update the table HTML after removing the last column
        tableHTML = tempTable.innerHTML;
      }
  
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write('<html><head><style type="text/css">' +
          '#backgroundImage{' +
          'min-height: 50vh;' +
          'position: relative;' +
          'margin: 0;' +
          '-webkit-print-color-adjust: exact !important;' +
          'color-adjust: exact !important;' +
          '}' +
          '#backgroundImage:before {' +
          'content: "";' +
          'position: absolute;' +
          'z-index: -1;' +
          'top: 0;' +
          'bottom: 0;' +
          'left: 0;' +
          'right: 0;' +
          'opacity: 0.04;' +
          `background: url('${logoUrl}') no-repeat center center;` +
          'background-size: contain;' +
          '}' +
          '</style></head><body id="backgroundImage"><div align="center">' +
          title +
          '</div><div className="main1"><table border="1" cellspacing="0">' +
          tableHTML +
          '</table></div><div align="center">This is a system-generated report; it does not require any signature or stamp.</div><div align="right"><img src="' +
          logoUrl +
          '" style="opacity: 0.1"></div></body></html>');
  
      printWindow.document.close();
      printWindow.focus();
  
      // Add an event listener to close the window after printing or canceling
      printWindow.onafterprint = () => {
        printWindow.close();
      };
  
      // Trigger the print dialog
      printWindow.print();
    };
  
    return (
      <div>
          <Button variant="primary" onClick={printTable}>
              <i className="mdi mdi-printer me-1"></i> Print
          </Button>
      </div>
    );
  };
  
  export default PrintTable;
  
